export const BACKEND_URL = "global.alto.exoware.xyz";
export const PUBLIC_KEY_HEX = "a59d10bde4e092aa5160047dfebdb509cf6fa2e2f3d3bd13e8a0defc18a783d37d11e98047cfbcaebb7b7e8ace89863f02da2272c86b4e5e97c47e575ae620c4a26f984ce718c8c6e6154954a2712b1a0f16698c0c6a3a0935b7e17fcfd02d48";
export const LOCATIONS: [[number, number], string][] = [
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"]
];